import { connect } from "react-redux";
import { IAppState } from "../../store";
import { AuthenticatedRoute as AuthenticatedRouteDefinition } from "./AuthenticatedRoute";

const mapStateToProps = (state: IAppState) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

export const AuthenticatedRoute = connect(mapStateToProps)(
  AuthenticatedRouteDefinition
);
